import {tgxApi} from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import {getFileName, serialize} from "../../../helpers/utils/Utils";
import {downloadFile} from "../../../helpers/utils/FileUtils";

export const linkedAccountsApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        searchLinkedAccounts: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/linkedAccount/search?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['linkedAccounts'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        createBulkLinkedAccounts: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/linkedAccount/bulk`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['linkedAccounts'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await  handleQueryErrorAndSuccess(queryFulfilled,"Created","Linked Account")
            },
        }),
        getLinkedAccountById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/linkedAccount/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['linkedAccountById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateLinkedAccount: build.mutation({
            query: ({id, requestBody}) => {
                return {
                    url: `/ajax/update/linkedAccount/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['linkedAccounts', 'linkedAccountById','userAuditableInfo'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await  handleQueryErrorAndSuccess(queryFulfilled,"Updated","Linked Account")
            },
        }),

        deleteLinkedAccountById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/linkedAccount/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['linkedAccounts'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Linked Account");
            },
        }),

        exportLinkedAccountData: build.query({
            query: (query) => {
                return {
                    url: `/export/linkedAccounts/export-csv`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("linkedAccount"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

    }),
});


export const {
    useCreateBulkLinkedAccountsMutation,
    useGetLinkedAccountByIdQuery,
    useUpdateLinkedAccountMutation,
    useSearchLinkedAccountsQuery,
    useLazyExportLinkedAccountDataQuery,
    useDeleteLinkedAccountByIdMutation,
} = linkedAccountsApi;